API_URL = 'https://noformat.herokuapp.com';
var stripe = Stripe('pk_live_515wCMaBoJ1slS7Z6tpg096xWhFntRq4iKtRnEJ0oYycTN5hqq1xuG9YIPmHpNnvimL0Ou2tbcc0OlfNXN4vXaLHL00Wvo3wKIS');
new Vue({
  el: '#pass-choice',
  delimiters: '<% %>',
  data() {
    return {
      priceId: undefined,
      user: userInit || {
        first_name: '',
        last_name: '',
        email: '',
        phone: '',
        address1: '',
        address2: '',
        city: '',
        country: '',
        code: '',
        product_1: null,
        product_2: null,
        product_3: null,
        sponsor_firstname: '',
        sponsor_lastname: '',
        sponsor_email: '',
        recipient_date: '',
        customer_source: '',
      },
      chosenProduct: { title: '' },
      products: [],
      initialProducts: [],
    };
  },
  created() {
    axios.get('/products.json?limit=5').then((response) => {
      this.initialProducts = response.data.products;
      this.products = response.data.products;
    });
    const passType = new URLSearchParams(window.location.search).get('pass_type');
    if (passType) {
      this.selectPass(passType);
    }
  },
  components: {
    VSelect: VueSelect.VueSelect,
  },
  methods: {
    selectPass(priceId) {
      this.priceId = priceId;
      this.$nextTick(() => {
        const tabTrigger = document.querySelector('[data-bs-target="#information"]');
        tabTrigger.click();
      });
    },
    openCheckoutSession(offer) {
      axios.post(API_URL + '/stripe/checkout', {
        price_id: this.priceId,
        user: this.user,
        offer: !!offer,
      }).then((response) => {
        if (response.status === 201) {
          window.location.href = '/pages/paiement-accepte'
        } else {
          stripe.redirectToCheckout({
            sessionId: response.data.session_id,
          });
        }
      });
    },
    startCouponScenario() {
      axios.get(API_URL + '/stripe/coupon', { params: { code: this.user.code } }).then((response) => {
        this.selectPass(response.data.price_id);
      });
    },
    fetchOptions(search, loading) {
      loading(true);
      if (search) {
        axios.get('/search/suggest.json?resources[type]=product&q=' + search).then((response) => {
          this.products = response.data.resources.results.products;
          loading(false);
        });
      } else {
        this.products = this.initialProducts;
        loading(false);
      }
    },
  },
});